var r, e;
function s() {
  if (e) return r;
  e = 1;
  return r = class {
    constructor(r, e) {
      this.urlOverride = e, this.sender = r;
    }
    send(r) {
      return new Promise((e, s) => {
        r.baseUrl = `${this.urlOverride}${r.baseUrlParam ? `/${r.baseUrlParam}` : ""}`, this.sender.send(r).then(e).catch(s);
      });
    }
  };
}
export { s as __require };